<template>
  <div class="bill-details" ref="container">
    <!-- <div class="nav acea-row">
      <div class="item" :class="types == 0 ? 'on' : ''" @click="changeTypes(0)">
        消费账户
      </div>
      <div class="item" :class="types == 1 ? 'on' : ''" @click="changeTypes(1)">
        体验奖励
      </div>
      <div class="item" :class="types == 2 ? 'on' : ''" @click="changeTypes(2)">
        奖励额度
      </div>
      <div class="item" :class="types == 3 ? 'on' : ''" @click="changeTypes(3)">
        电子账户
      </div>
	  <div class="item" :class="types == 7 ? 'on' : ''" @click="changeTypes(7)">
	    优先分红
	  </div>
    </div> -->
    <div class="my-promotion">
      <div class="header" style="background-color: rgb(236, 93, 89) !important;">
         <div class="num" v-if="types==0">{{ gu_you }}</div>
         <div class="num" v-if="types==1">{{ t_money }}</div>
         <div class="num" v-if="types==2">{{ integral }}</div>
         <div class="num" v-if="types==3">{{ d_money }}</div>
		 <div class="num" v-if="types==7">{{ f_money }}</div>
         <div class="name acea-row row-center-wrapper">
            <div v-if="types==0">我的优先股</div> 
        </div>
      </div>
    </div>
	
    <div class="my-account"  v-if="types==0||types==3">
      <div class="wrapper">
        <div class="nav acea-row row-middle">  
          <router-link class="item" :to="''" v-if="types==0">
            <div class="pictrue"><img src="data:image/png;base64,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" /></div>
            <div>股权交易</div>
          </router-link> 
          <router-link class="item" :to="'/user/bill/7'">
            <div class="pictrue"><img src="data:image/png;base64,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"></div>
            <div>股权分红</div>
          </router-link>
         <!-- <router-link class="item" :to="'/user/transfer'">
            <div class="pictrue"><img src="data:image/png;base64,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"></div>
            <div>会员转账</div>
          </router-link> -->
        </div>
      </div>
    </div>
	<div class="intro">
		 <div class="introtitle">优先股与公司同命运共发展</div>
		 <p>1、本优先股，只有每天分红权，没有管理权，股金永远不退，优先股满一年后可以转让，可以出售。</p> 
		 <p>2、优先股永远有分红权，优先股出售价格高低，不影响分红利润。</p>
		 <p>3、所有优先股加权分红公司每天总营业额的3.5%，每天系统自动结算分红。</p>
		 
	</div>
    <div class="sign-record">
      <div class="list">
        <div class="item">
          <div class="data">入股记录</div>
          <div class="listn" v-for="(val, key) in list" :key="key">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">股数：{{ val.amount }}</div>
                <div>入股时间：{{ val.addtime }}</div>
              </div>
              <div class="num" :class="val.pm == 0 ? 'font-color-red' : ''">
                {{ val.pm == 0 ? "-" : "+" }}{{ val.number }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getGuYouInfo,getBalance } from "../../api/user";
import Loading from "@components/Loading";
export default {
  name: "UserGuYou",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      gu_you: 0,
      d_money: 0,
      t_money: 0,
	  f_money:0,
      integral: 0,
      types: 0,
      where: {
        page: 0,
        limit: 5
      },
      list: [],
      loaded: false,
      loading: false
    };
  },
  watch: {
    "$route.params.types": function(newVal) {
      let that = this;
      if (newVal != undefined) {
        that.types = newVal;
        that.list = [];
        that.where.page = 1;
        that.loaded = false;
        that.loading = false;
        that.getIndex();
      }
    },
    types: function() {
      this.getIndex();
    }
  },
  mounted: function() {
    let that = this;
    //that.types = that.$route.params.types;
	that.types = 0;
    that.getIndex();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getIndex();
    });
  },
  methods: {
    code: function() {
      this.sendCode();
    },
    changeTypes: function(val) {
      if (val != this.types) {
        this.types = val;
        this.list = [];
        this.where.page = 1;
        this.loaded = false;
        this.loading = false;
      }
    },
    getIndex: function() {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true; 
      getBalance().then(
        res => {
          that.gu_you = res.data.gu_you;
          that.integral = res.data.integral;
          that.d_money = res.data.d_money;
          that.t_money = res.data.t_money;
		  that.f_money = res.data.f_money;
          that.orderStatusSum = res.data.orderStatusSum;
          that.recharge = res.data.recharge;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
      getGuYouInfo(that.where, that.types).then(
        res => {
          that.loading = false;
          that.loaded = res.data.list.length < that.where.limit;
          that.where.page = that.where.page + 1;
          that.list.push.apply(that.list, res.data.list);
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
<style>
  .my-account .wrapper .nav .item .pictrue{ width: 0.6rem; height: 0.6rem; margin-bottom: 0;}
  .my-account .wrapper{ margin-bottom: 0; padding-bottom: 0;}
  .intro{ padding: 0.3rem; background-color: #fff;}
  .introtitle{ text-align: center; font-size: 0.36rem; font-weight: 600; margin-bottom: 0.3rem;}
</style>
